require('angular');

angular.module('app').controller('contactController', ContactController);

ContactController.$inject = ['$http', '$window','ecommerce'];

function ContactController($http, $window, ecommerce) {
    var vm = this;
    vm.submit = submit;
    vm.inProgress = false;
    vm.success = null;

    vm.responseSuccess = null;
    vm.responseMsg = null;
    vm.errors           = null;
    vm.termsAgreement = false;

    vm.message = {
        /**
         * Decides whether message should go to HR or CS
         */
        channel:'',
        author: '',
        email: '',
        content: '',
        serviceName: ''
    };

    function isEmpty(value){
        return value === '';
    }

    function submit(event) {
        if(vm.inProgress){
            return;
        }

        vm.recaptcha = null;
        vm.inProgress = true;
        vm.responseMsg = null;
        vm.errors = null;

        let recaptchaResponse = angular.element('.g-recaptcha-response').val();

        if (isEmpty(recaptchaResponse) || isEmpty(vm.message['author']) || isEmpty(vm.message['email']) || isEmpty(vm.message['content'])) {
            vm.errors = vm.message['channel'] == 'HR' ? 'Wypełnij pola oznaczone czerwoną gwiazdką' : 'Please fill all fields marked with red star';
            vm.inProgress = false;
            return;
        }
        let file  = document.getElementById("contact_us_file");
        if(file !==null){
            file = file.files[0];
        }


        if(file != undefined && file != null && file.type !== 'application/pdf'){
            vm.errors = 'Wymagany format załącznika to pdf';
            vm.inProgress = false;
            return;
        }

        if(file != undefined && file != null && file.size > 10485760){
        //if(file != undefined && file != null && file.size > 100){
            vm.errors = 'Maksymalny rozmiar pliku 10M';
            vm.inProgress = false;
            return;
        }

        if(vm.termsAgreement == false){
            vm.errors = vm.message['channel'] == 'HR' ? 'Wyraź proszę zgodę na przetwarzanie informacji' : 'Agree for terms of personal data processing';
            vm.inProgress = false;
            return;
        }


        let fileReader     = null;
        if (file != undefined && file != null  ) {
            fileReader    = new FileReader();
            fileReader.readAsDataURL(file);
        }

        setTimeout(() => {
            $.post( "/wp-admin/admin-ajax.php", { action: 'send-contact-message',
                author: vm.message['author'],
                channel: vm.message['channel'],
                email: vm.message['email'],
                content: vm.message['content'],
                service_name: vm.message['serviceName'],
                attachment: !!fileReader ? JSON.stringify(fileReader.result) : null ,
                captchaResponse: recaptchaResponse
            },function(data, status){
                $('#contactus').hide();
                vm.inProgress = false;
                vm.success = data.success;
                vm.responseMsg = typeof data.data.exception !== 'undefined' ? data.data.exception : data.data.message;
                ecommerce.generateLead(48, $('#currency_choice_1').val());
                var getMeTo = document.getElementById("contactus");
                getMeTo.scrollIntoView({behavior: 'smooth'}, true);
                $('#contactus_msg').show();
            });

            /*

            $http({
                method: 'POST',
                async: false,
                dataType: 'json',
                url: '/wp-admin/admin-ajax.php',
                params: {
                    action: 'send-contact-message',
                    author: vm.message['author'],
                    channel: vm.message['channel'],
                    email: vm.message['email'],
                    content: vm.message['content'],
                    service_name: vm.message['serviceName'],
                    attachment: !!fileReader ? JSON.stringify(fileReader.result) : null ,
                    captchaResponse: recaptchaResponse,
                },
                data: {
                    action: 'send-contact-message',
                    author: vm.message['author'],
                    email: vm.message['email'],
                    channel: vm.message['channel'],
                    content: vm.message['content'],
                    service_name: vm.message['serviceName'],
                    attachment: !!fileReader ? JSON.stringify(fileReader.result) : null ,
                    captchaResponse: recaptchaResponse,
                }
            }).then(onSuccess, onFail);
            */

        }, "1000");



    }

    function onSuccess(response) {
        vm.inProgress = false;
        vm.success = response['data']['success'];
        vm.responseMsg = typeof response['data']['exception'] !== 'undefined' ? response['data']['exception'] : response['data']['data']['message'];
        ecommerce.generateLead(48, $('#currency_choice_1').val());
        var getMeTo = document.getElementById("contactus");
        getMeTo.scrollIntoView({behavior: 'smooth'}, true);

    }

    function onSuccessJQ(data) {
        vm.inProgress = false;
        vm.success = data.success;
        vm.responseMsg = typeof data.data.exception !== 'undefined' ? data.data.exception : data.data.message;
        ecommerce.generateLead(48, $('#currency_choice_1').val());
        var getMeTo = document.getElementById("contactus");
        getMeTo.scrollIntoView({behavior: 'smooth'}, true);

    }

    function onFail(err) {
        var getMeTo = document.getElementById("contactus");
        getMeTo.scrollIntoView({behavior: 'smooth'}, true);
        vm.errors = 'Nieobsługiwany typ pliku';
        vm.inProgress = false;
        return;
    }
}
